export default "__VITE_ASSET__DpWNjmn3__"